import { render, staticRenderFns } from "./ModalTerminosAvisos.vue?vue&type=template&id=1fcd8753&scoped=true&"
import script from "./ModalTerminosAvisos.vue?vue&type=script&lang=js&"
export * from "./ModalTerminosAvisos.vue?vue&type=script&lang=js&"
import style0 from "./ModalTerminosAvisos.vue?vue&type=style&index=0&id=1fcd8753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd8753",
  null
  
)

export default component.exports